import { render, staticRenderFns } from "./TariffFactor.vue?vue&type=template&id=4d2cf110&"
import script from "./TariffFactor.vue?vue&type=script&lang=js&"
export * from "./TariffFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports